import { t } from "i18next";

export const purposeTypes = {
  EMPLOYMENT: t("Employment"),
  LICENSE: t("Licence"),
  OTHER: t("Other (Position of Trust/Probity)"),
};
